import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card } from "antd";
import "./workHome.css";
import sticker from '../../assets/stickers-01.png'
import branding from '../../assets/branding-01.png'
import illustrate from '../../assets/illustration-01.png'
import webmosys from '../../assets/webmobilesys-01.png'
import photog from '../../assets/photography-01.png'
import layout from '../../assets/layout-01.png'

class WorkHome extends Component {
  handleCategory(cat) {
    return (
      <Link to="/work" className="category-item">
        <li>
          <i>{cat}</i>
        </li>
      </Link>
    );
  }
  render() {
    return (
      <div className="services">
        <div className="service-item">
          <img src={branding} alt="branding" className="service-icon"/>
          <h3>Branding</h3>
          <p>to create your idea</p>
        </div>
        <div className="service-item">
          <img src={illustrate} alt="illustration" className="service-icon"/>
          <h3>Illustrate</h3>
          <p>to form your brand</p>
        </div>
        <div className="service-item">
          <img src={layout} alt="layout design" className="service-icon"/>
          <h3>Layout</h3>
          <p>to design what you have for your brand</p>
        </div>
        <div className="service-item">
          <img src={photog} alt="photography" className="service-icon"/>
          <h3>Photography</h3>
          <p>to capture your brand</p>
        </div>
        <div className="service-item">
          <img src={sticker} alt="stickers" className="service-icon"/>
          <h3>Stickers</h3>
          <p>to produce outputs to strenghten your brand</p>
        </div>
        <div className="service-item">
          <img src={webmosys} alt="websystems" className="service-icon"/>
          <h3>Web Systems</h3>
          <p>to build your brand through digital strategy</p>
        </div>
      </div>
    );
  }
}

export default WorkHome;



// WEBPACK FOOTER //
// ./src/components/pages/workHome.js